// @flow

import * as React from 'react';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';

import { useAuth } from '@locus-taxy/auth-react';

import config from 'config';

const SsoRedirectContainer = (): React.Node => {
    const auth = useAuth();
    const location = useLocation();

    const { clientId, providerId, connection } = React.useMemo(() => {
        return queryString.parse(location.search);
    }, [location]);

    React.useEffect(() => {
        const login = async () => {
            await auth.login({
                appState: { currentLocation: location },
                clientId,
                providerId,
                devo: config.env === 'devo' ? config.devo : undefined,
                extraParams: connection ? { connection } : null,
                // NOTE: this component is only for redirection to ULP, we don't want it to be part of history.
                // Expected User behaviour: If user click back button from ULP,
                // user should be redirected back to login page not to this component else user will redirect back
                // to ULP, so using replace (default behaviour is push)
                redirectMethod: 'replace'
            });
        };
        login();
    }, [auth, location, clientId, providerId, connection]);

    return null;
};

export default SsoRedirectContainer;
